(() => {
  "use strict";

  const DEFAULTS = { min: 4, max: 9, hours: 1 };

  function getConfig() {
    const c = (typeof window !== "undefined" && window.__stockCountConfig) || {};
    const min = Number.isFinite(c.min) ? c.min : DEFAULTS.min;
    const max = Number.isFinite(c.max) ? c.max : DEFAULTS.max;
    const hours = Number.isFinite(c.hours) ? c.hours : DEFAULTS.hours;
    return { min, max, hours };
  }

  function setCookie(name, value, hours) {
    const d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(
      value
    )};expires=${d.toUTCString()};path=/;SameSite=Lax`;
  }

  function getCookie(name) {
    const cookieName = `${name}=`;
    const parts = document.cookie ? document.cookie.split(";") : [];
    for (let c of parts) {
      c = c.trim();
      if (c.indexOf(cookieName) === 0) {
        return decodeURIComponent(c.substring(cookieName.length));
      }
    }
    return "";
  }

  function getRandomIntInclusive(min, max) {
    const lo = Math.ceil(min);
    const hi = Math.floor(max);
    return Math.floor(Math.random() * (hi - lo + 1)) + lo;
  }

  
  function getPidForElement(el) {
    return el.getAttribute("data-product-id") || window.__productId || "";
  }

  function groupByPid(nodeList) {
    const map = new Map();
    nodeList.forEach((el) => {
      const pid = getPidForElement(el);
      if (!pid) return;
      if (!map.has(pid)) map.set(pid, []);
      map.get(pid).push(el);
    });
    return map;
  }

  function updateStockCounts() {
    const { min, max, hours } = getConfig();
    const nodes = Array.from(document.querySelectorAll(".stockCount"));
    if (!nodes.length) return;

    const byPid = groupByPid(nodes);
    if (!byPid.size) return;

    byPid.forEach((els, pid) => {
      const cookieName = `stockCount_${pid}`;
      let value = getCookie(cookieName);

      if (!value) {
        value = String(getRandomIntInclusive(min, max));
        setCookie(cookieName, value, hours);
      }

      els.forEach((el) => {
        el.textContent = value;
      });
    });
  }

  // Fire when DOM is ready (handles both defer and inline inclusion)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateStockCounts);
  } else {
    updateStockCounts();
  }
})();
